/**
 * Shared styles for the refractometer QC log (InsCreate / InsEdit).
 *
 * A theme function rather than a plain object, so the log picks up the app
 * theme from src/layout/themes.js instead of the hardcoded silver-and-black it
 * used to carry. That mattered beyond taste: the old colours were fixed values,
 * so in dark mode the form rendered black-on-black.
 *
 * Both screens import this, which is also what keeps them from drifting apart -
 * they previously held byte-identical copies of the same style block.
 */
const formStyles = theme => ({
    inlineBlock: {
        display: 'inline-flex',
        margin: theme.spacing(0.5),
        padding: theme.spacing(0.5),
    },
    inlineBlockLeft: {
        display: 'inline-flex',
        float: 'left',
        marginRight: theme.spacing(2),
    },
    hidden: {
        display: 'none',
    },
    inputStyle: {
        width: 90,
    },
    controlInputStyle: {
        width: 110,
    },
    /** Row headers down the left of the grid, and the narrow initial columns. */
    labelStyle: {
        width: 150,
        backgroundColor: theme.palette.type === 'dark'
            ? theme.palette.grey[800]
            : theme.palette.grey[100],
        color: theme.palette.text.primary,
        fontWeight: 600,
    },
    iniLabelStyle: {
        width: 80,
        backgroundColor: theme.palette.type === 'dark'
            ? theme.palette.grey[800]
            : theme.palette.grey[100],
        color: theme.palette.text.primary,
        fontWeight: 600,
    },
    dateStyle: {
        width: 120,
    },
    tableStyle: {
        margin: 'auto',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        fontSize: theme.typography.pxToRem(13),
        '& td': {
            padding: theme.spacing(0.75, 1),
            borderBottom: `1px solid ${theme.palette.divider}`,
            verticalAlign: 'middle',
        },
        '& tr:last-child td': {
            borderBottom: 'none',
        },
        '& .MuiFormControl-root': {
            width: '100%',
        },
    },
    h3: {
        textAlign: 'center',
        width: '100%',
        color: theme.palette.primary.main,
        fontWeight: 600,
    },
    /** The identity block above the grid - no cell borders. */
    clearTableStyle: {
        margin: 'auto',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        border: 'none',
        color: theme.palette.text.primary,
        fontSize: theme.typography.pxToRem(13),
        '& td': {
            padding: theme.spacing(0.75, 1),
            verticalAlign: 'middle',
        },
    },
    /**
     * Cells whose value comes from the inventory lot rather than from the
     * person filling in the log. Tinted so it reads as reference data, not as
     * a field someone forgot to complete.
     */
    derivedStyle: {
        width: 110,
        '& .MuiFilledInput-root': {
            backgroundColor: theme.palette.action.hover,
        },
    },
});

export default formStyles;
